import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryList(params) {
  return request('//actionNotificationAttachmentMapping/paged', {
    params: toQuery(params),
  });
}

export async function queryEditItemNotification({ id, params }) {
  return request(`/actionNotificationAttachmentMapping/${id}`, {
    params: toQuery(params),
  });
}

export async function queryAddNewNotification(params) {
  return request.post(`/actionNotificationAttachmentMapping`, {
    data: params,
  });
}

export async function queryAddEditNotification(params) {
  return request.put('/actionNotificationAttachmentMapping', {
    data: params,
  });
}

export async function queryDeleteItem(id) {
  return request.delete(`/actionNotificationAttachmentMapping/${id}`, {});
}
